const Spinner = () => {
  return (
    <div className="div-spinner">
      <div className="spinner-border spinner-custom" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
